import React from 'react';

const BirthdayDropdowns = ({ onChange, value }) => {
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 125 }, (_, i) => currentYear - i);

  const handleChange = (e) => {
    const { name, value: selectedValue } = e.target;
    onChange({
      ...value,
      [name]: selectedValue
    });
  };

  return (
    <div className="flex space-x-2">
      <select 
        name="day" 
        onChange={handleChange} 
        value={value.day}
        className="w-1/4 p-2 border rounded text-lg"
      >
        <option value="">Day</option>
        {days.map(d => (
          <option key={d} value={d}>{d}</option>
        ))}
      </select>
      <select 
        name="month" 
        onChange={handleChange} 
        value={value.month}
        className="w-2/5 p-2 border rounded text-lg"
      >
        <option value="">Month</option>
        {months.map((m, index) => (
          <option key={m} value={index + 1}>{m}</option>
        ))}
      </select>
      <select 
        name="year" 
        onChange={handleChange} 
        value={value.year}
        className="w-1/3 p-2 border rounded text-lg"
      >
        <option value="">Year</option>
        {years.map(y => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
};

export default BirthdayDropdowns;